
function withLeadingZero (string) {
   return (string < 10) ? `0${string}` : string
}

function formattedTimeString (dateVal) {
   const date = new Date(dateVal)
   const H = withLeadingZero(date.getHours())
   const i = withLeadingZero(date.getMinutes())
   return `${H}:${i}`
}

function formattedDateString (dateVal) {
   if (dateVal == null) {
      return null
   }
   const date = new Date(dateVal)
   const Y = date.getFullYear()
   const m = withLeadingZero(date.getMonth() + 1)
   const d = withLeadingZero(date.getDate())

   return `${d}.${m}.${Y}`
}

function formattedDateTimeString (dateVal) {
   return `${formattedDateString(dateVal)} ${formattedTimeString(dateVal)}`
}

export { formattedTimeString, formattedDateString, formattedDateTimeString }
